
export default {
  Region: 'us-west-2',
  UserPoolId: 'us-west-2_1LVd3llAy',
  ClientId: '3e9v0vjerjeet80b8q59mg6uq2',
  IdentityPoolId: 'us-west-2:4b0a716a-e805-4c4a-9b6a-a84690345f0a'
}
